import React, {useState, useEffect} from 'react'

import {useNavigate} from "react-router-dom";
import {useApi} from "../ApiSession";
import {DefaultButton} from "../widgets/Buttons";
import { formatDistanceToNow } from 'date-fns';
import { parseISO } from "date-fns";
import DocLink from "./DocLink";
import UpDownToggle from "../widgets/UpDownToggle";
import {alphabetical, sort} from "radash"

const Ago = ({timeStr}) => {

    const [d, setD] = useState(() =>{
        return parseISO(timeStr)
    })

    const timeAgo = formatDistanceToNow(d, { addSuffix: true })
    return timeAgo
}


const sortFuncs = [
    p => p.name,
    p => p.time_created,
    p => p.time_last_activity,
    p => p.type,
    p => p.state
]


export const PipelineList = ({showOnly}) => {

    const [pipelines, setPipelines] = useState(null)

    const navigate = useNavigate()

    const api = useApi()

    const [sortedPipelines, setSortedPipelines] = useState([])

    const [sortSpec, setSortSpec] = useState({idx: 1, direction: -1})

    const doSort = (pipelines, sortSpec) =>
        alphabetical(pipelines, p => sortFuncs[sortSpec.idx](p), sortSpec.direction === 1 ? 'desc': 'asc')

    useEffect(() => {
        api.getLsPipelines(showOnly).then(res => {
            setPipelines(res)
            setSortedPipelines(doSort(res, sortSpec))
        })
    },[])


    useEffect(() => {
        if(pipelines) {
            const sp = doSort(pipelines, sortSpec)

            console.log(sp.map(p => sortFuncs[sortSpec.idx](p)).join(","))
            setSortedPipelines(sp)
        }
    }, [`${sortSpec.idx}:${sortSpec.direction}`])


    const LinkToPipeline = ({label, href}) =>
        <a href={href} className="font-medium text-blue-600 dark:text-blue-500 hover:underline">{label}</a>

    const Th = ({title, idx}) =>
        <th scope="col" className="px-6 py-3 cursor-default">
            <div className="flex justify-start" onClick={
                () => setSortSpec({
                    idx,
                    direction: sortSpec.direction === -1 ? 1 : -1
                })
            }>
              <div>{title}</div>
              <div className={"ml-4"}>
                  <UpDownToggle
                      value={sortSpec.direction}
                      opacity={idx === sortSpec.idx ? 100 : 0}
                  />
              </div>
            </div>
        </th>


    return <div className="relative overflow-x-auto">
        <table className="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
            <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
            <tr>
                <Th title={"instance name"} idx={0}/>
                <Th title={"creation time"} idx={1}/>
                <Th title={"last activity"} idx={2}/>
                <Th title={"type"} idx={3}/>
                <Th title={"state"} idx={4}/>
            </tr>
            </thead>
            <tbody>
            {
                sortedPipelines && sortedPipelines.map(p => <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700" key={p.pid}>
                        <td scope="row" className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white">
                            <LinkToPipeline label={p.name} href={`/pipelines${p.pid}`}/>
                        </td>
                        <td>
                            <Ago timeStr={p.time_created}/>
                        </td>
                        <td>
                            <Ago timeStr={p.time_last_activity}/>
                        </td>
                        <td className="px-6 py-4">
                            {
                                p.doc_root ?
                                    <DocLink pipelineType={p.type} markdownFile={'readme.md'} linkOnly={true}/> :
                                    p.type
                            }
                        </td>
                        <td className="px-6 py-4">
                            <LinkToPipeline label={p.state} href={`/pipelines${p.pid}`}/>
                        </td>
                    </tr>
                )
            }
            </tbody>
        </table>

        <div className={"pt-6"}>
            <DefaultButton caption={"Create New Pipeline"} onClick={() => {
                navigate("/pipelines/createNew")
            }}/>
        </div>
    </div>
}